import React, { Component } from 'react'
import Jumbotron from '../components/Jumbotron';
import Gallery from 'react-photo-gallery';
import Lightbox from 'react-images';

const aduPhotos = [
  { src: './images/adu/ADU_FLOOR_PLAN_1.png', alt: 'ADU floor plan drawing 1', caption: '#1 ADU floor plan drawing', id: "0" },
  { src: './images/adu/ADU_FLOOR_PLAN_2.png', alt: 'ADU floor plan drawing 2', caption: '#2 ADU floor plan drawing', id: "1" },
  { src: './images/adu/ADU_FLOOR_PLAN_3.png', alt: 'ADU floor plan drawing 3', caption: '#3 ADU floor plan drawing', id: "2" },
];

const cipPhotos = [
    { src: './images/cip/S1-CIP-REBAR.jpg', alt: 'cast in place rebar 1', caption: '#1 Cast in place rebar', id: "3" },
    { src: './images/cip/S2-CIP-REBAR.jpg', alt: 'cast in place rebar 2', caption: '#2 Cast in place rebar', id: "4" },
    { src: './images/cip/S3-CIP-REBAR.jpg', alt: 'cast in place rebar 3', caption: '#3 Cast in place rebar', id: "5" },
    { src: './images/cip/S4-CIP-REBAR.jpg', alt: 'cast in place rebar 4', caption: '#4 Cast in place rebar', id: "6" },
    { src: './images/cip/S5-CIP-REBAR.jpg', alt: 'cast in place rebar 5', caption: '#5 Cast in place rebar', id: "7" },
    { src: './images/cip/S6-CIP-REBAR.jpg', alt: 'cast in place rebar 6', caption: '#6 Cast in place rebar', id: "8" },
    { src: './images/cip/S7-CIP-REBAR.jpg', alt: 'cast in place rebar 7', caption: '#7 Cast in place rebar', id: "9" },
    { src: './images/cip/S8-CIP-REBAR.jpg', alt: 'cast in place rebar 8', caption: '#8 Cast in place rebar', id: "10" },
    { src: './images/cip/S9-CIP-REBAR.jpg', alt: 'cast in place rebar 9', caption: '#9 Cast in place rebar', id: "11" }
];

const prPhotos = [
  { src: './images/pr/A1-POOLREBAR.jpg', alt: 'pool rebar shop drawing 1', caption: '#1 Pool rebar shop drawing', id: "12" },
  { src: './images/pr/A2-POOLREBAR.jpg', alt: 'pool rebar shop drawing 2', caption: '#2 Pool rebar shop drawing', id: "13" },
  { src: './images/pr/A3-POOLREBAR.jpg', alt: 'pool rebar shop drawing 3', caption: '#3 Pool rebar shop drawing', id: "14" },
];

const ssrPhotos = [
    { src: './images/ss/A-1-SOFTSTORY-RETROFIT.jpg', alt: 'soft story retrofit as built plans 1', caption: '#1 Soft story retrofit', id: "15" },
    { src: './images/ss/A-2-SOFTSTORY-RETROFIT.jpg', alt: 'soft story retrofit as built plans 2', caption: '#2 Soft story retrofit', id: "16" },
    { src: './images/ss/A-3-SOFTSTORY-RETROFIT.jpg', alt: 'soft story retrofit as built plans 3', caption: '#3 Soft story retrofit', id: "17" },
    { src: './images/ss/A-4-SOFTSTORY-RETROFIT.jpg', alt: 'soft story retrofit as built plans 4', caption: '#4 Soft story retrofit', id: "18" }
];

const wrPhotos = [
    { src: './images/wr/A1-WALLREBAR-SITE.jpg', alt: 'wall rebar site 1', caption: '#1 Wall rebar site', id: "19" },
    { src: './images/wr/A2-WALLREBAR-SITE.jpg', alt: 'wall rebar site 2', caption: '#2 Wall rebar site', id: "20" },
    { src: './images/wr/A3-WALLREBAR-SITE.jpg', alt: 'wall rebar site 3', caption: '#3 Wall rebar site', id: "21" }
];

class Projects extends Component {
    constructor() {
        super();
        this.state = { currentImage: 0 };
    }

    openLightbox = (event, obj) => {
        this.setState({
            currentImage: parseInt(event.target.id, 10),
            lightboxIsOpen: true
        });
    }

    closeLightbox = () => {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    }

    gotoNext = () => {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    }

    gotoPrevious = () => {
        this.setState({
            currentImage: this.state.currentImage - 1,
        });
    }

    render() {
        const allPhotos = aduPhotos.concat(cipPhotos, prPhotos, ssrPhotos, wrPhotos);
        return (
            <div>
                <Jumbotron title='Projects' subtext='Current and past projects'/>
                <div className="p-5">
                    <div className="row">
                        <div className="col-12 mb-5">
                            <h3>Accessory Dwelling Unit (ADU) Floor Plan Drawings<small className="text-muted"> (3 - Click to enlarge)</small></h3>
                            <Gallery photos={aduPhotos} onClick={this.openLightbox} />
                            <Lightbox
                                images={allPhotos}
                                // showThumbnails={true}
                                backdropClosesModal={true}
                                isOpen={this.state.lightboxIsOpen}
                                onClose={this.closeLightbox}
                                onClickPrev={this.gotoPrevious}
                                onClickNext={this.gotoNext}
                                currentImage={this.state.currentImage}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 mb-5">
                            <h3>Architectural Cast in Place Shop Drawings<small className="text-muted"> (9 - Click to enlarge)</small></h3>
                            <Gallery photos={cipPhotos} onClick={this.openLightbox} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 mb-5">
                            <h3>Pool Rebar & Cast in Place Shop Drawings<small className="text-muted"> (3 - Click to enlarge)</small></h3>
                            <Gallery photos={prPhotos} onClick={this.openLightbox} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 mb-5">
                            <h3>Soft Story Retrofit "As Built Plans"<small className="text-muted"> (4 - Click to enlarge)</small></h3>
                            <Gallery photos={ssrPhotos} onClick={this.openLightbox} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 mb-5">
                            <h3>Wall Rebar Shop Drawings<small className="text-muted"> (3 - Click to enlarge)</small></h3>
                            <Gallery photos={wrPhotos} onClick={this.openLightbox} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Projects;


// WEBPACK FOOTER //
// ./src/views/Projects.js